// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"142":"44c751a8","159":"261e8ec6","342":"f226ecc5","440":"41832a59","576":"328b4425","885":"3dd29c18"}[chunkId] + ".js";
};